import { AppConfig } from "../utils/AppConfig.js";
import { AuthService } from "./AuthService.js";

// Los 4 accesos del home son fijos y transversales al asegurado. Lo que depende de la póliza
// (auxilio mecánico, documentación de esa póliza) vive en la pantalla de detalle, no acá.
//
// Acción: "proximamente" → aviso; "whatsapp" → wa.me con mensaje pre-escrito.
// Los números salen de AppConfig.contacto (.env), no de la API.

const firma = () => {
  const u = AuthService.getUsuario();
  if (!u) return "";
  const nombre = ((u.Nombre || "") + " " + (u.Apellido || "")).trim();
  const doc = u.Documento ? " (" + (u.TipoDocumento || "DNI") + " " + u.Documento + ")" : "";
  return nombre ? ", soy " + nombre + doc : "";
};

const waHref = (numero, mensaje) => {
  const limpio = String(numero || "").replace(/\D/g, "");
  if (!limpio) return "";
  return "https://wa.me/" + limpio + "?text=" + encodeURIComponent(mensaje);
};

export class AccesosService {
  static listar() {
    const yo = firma();

    return [
      {
        Clave: "documentos",
        Titulo: "Mis Documentos",
        Icono: "fa-folder-open",
        Accion: "proximamente",
        Href: "#",
      },
      {
        Clave: "recordatorios",
        Titulo: "Mis Recordatorios",
        Icono: "fa-bell",
        Accion: "proximamente",
        Href: "#",
      },
      {
        Clave: "siniestro",
        Titulo: "Denunciar Siniestro",
        Icono: "fa-car-burst",
        Accion: "whatsapp",
        Href: waHref(
          AppConfig.contacto.whatsappSiniestros,
          "Hola" + yo + ". Necesito denunciar un siniestro."
        ),
      },
      {
        Clave: "contacto",
        Titulo: "Contactanos",
        Icono: "fa-comments",
        Accion: "whatsapp",
        Href: waHref(
          AppConfig.contacto.whatsappContacto,
          "Hola" + yo + ". Quiero hacer una consulta."
        ),
      },
    ].filter((a) => a.Href); // sin número configurado, el acceso no se muestra
  }

  /** WhatsApp de la oficina, con mensaje libre. Se usa fuera del menú (estado vacío, detalle). */
  static whatsappContacto(mensaje) {
    return waHref(AppConfig.contacto.whatsappContacto, "Hola" + firma() + ". " + mensaje);
  }
}
